import { render, staticRenderFns } from "./RestartAccountConfirmation.vue?vue&type=template&id=b1af74f6&"
import script from "./RestartAccountConfirmation.vue?vue&type=script&lang=js&"
export * from "./RestartAccountConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports